import { ImageAttachmentData } from "~/models/card";
import { StarRating } from "~/common/charity/StarRating";
import { AttachmentImage } from "~/common/components/image/AttachmentImage";

export const FundItemFooterImage = ({
  rating,
  starRating,
  image,
}: {
  rating?: number;
  starRating: number;
  image?: ImageAttachmentData;
}) => {
  return (
    <div className="tw:flex tw:justify-between tw:items-center">
      <div className="tw:flex tw:flex-col">
        <div className="tw:text-[1.25rem]">
          Score: <strong>{rating ? `${rating}%` : "N/A"}</strong>
        </div>
        <StarRating
          rating={starRating ? Number(starRating) : 0}
          width={150}
          height={0}
        />
      </div>
      <div className="tw:text-[3rem] tw:font-bold tw:leading-none">
        <AttachmentImage image={image} className="tw:!h-[70px]" />
      </div>
    </div>
  );
};
